import * as Masonry from 'masonry-layout';

import { GetConfigForValue, GetDefaultConfig } from '../models/processTypeConfigModel';
import { updateSimpleProcessFields } from '../components/simpleProcess';
import { updateProcessTypeChangedAlert } from '../components/processTypeChangedAlert';
import { updateProgressBar } from '../components/progressBar';

$(() => {
    $('#processTypeMasonryLayout').on('shown.bs.collapse', () => {
        new Masonry('.masonry-layout', {
            itemSelector: ".masonry-item",
            percentPosition: true
        });
    });

    let originalValue = $("#processListMasonryToggle").attr("data-original-value");

    onProcessTypeChanged(originalValue, originalValue);

    $('.processType-radio').on('change', (event) => {
        let currentTarget = event.currentTarget as HTMLInputElement;
        let displayName = currentTarget.dataset.displayname;

        $('#processListMasonryToggle').text(displayName);

        onProcessTypeChanged(currentTarget.value, originalValue);
    });
})

function onProcessTypeChanged(newValue: string, originalValue: string) {
    let currentConfig = GetConfigForValue(newValue) || GetDefaultConfig();

    updateSimpleProcessFields(currentConfig);
    updateProcessTypeChangedAlert(newValue, originalValue);
    updateProgressBar(newValue);
}
